import RouterContainer from "./RoutesContainer/routesContainer";
import Notification from "./common/notification";
import { useTranslation } from 'react-i18next';
import './i18'; 
import { useEffect } from "react";
import { getLocalStorageItem } from "./common/LocalStorageService";

const getLanguage = () => {
  const user = getLocalStorageItem("userData") || getLocalStorageItem("language");
  return user?.lang_code || 'en';
}

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Retrieve the language from localStorage, default to navigator.language if not found
    const savedLangCode = getLanguage() || navigator.language || 'en';
    
    // Set the language in i18n and save it to localStorage
    i18n.changeLanguage(savedLangCode);
  }, [i18n]);
  return (
    <div id="wrapper">
      <RouterContainer />
      <Notification/>
    </div>
  );
}

export default App;